import { useAuth0 } from '@brighte/passwordless-authenticator';
import { Box } from '@spark-web/box';
import { Button } from '@spark-web/button';
import { Heading } from '@spark-web/heading';
import { InformationCircleIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { LABELS, LAND_TITLE_ELIGIBILITY_CRITERIA } from '@utils';
import EligibilityStepHeader from './EligibilityStepHeader';

type TitleOwnerTermsProps = {
  productName: string;
  onContinue: () => void;
};

function TitleOwnerTerms({ productName, onContinue }: TitleOwnerTermsProps) {
  const { user } = useAuth0();

  return (
    <Stack padding="xlarge" gap="xxlarge">
      <EligibilityStepHeader currentStep={1} totalSteps={5} productName={productName} />

      <Heading level="1">
        {user?.given_name ? `Hi ${user.given_name}, let's check your eligibility` : "Let's check your eligibility"}
      </Heading>

      <Text>
        Brighte is an official finance provider for the NSW Government, making your sustainable home upgrade more
        affordable and accessible.
      </Text>

      <Text>To get started we need to do a quick program eligibility check.</Text>

      <Stack gap="medium">
        {LAND_TITLE_ELIGIBILITY_CRITERIA.map((criterion, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            gap="medium"
            padding="large"
            borderRadius="medium"
            background="surfaceMuted"
            borderWidth="standard"
            border="standard"
          >
            <Box flexShrink={0}>{criterion.icon}</Box>
            <Box flex={1}>{criterion.text}</Box>
          </Box>
        ))}
      </Stack>

      <Button onClick={onContinue} tone="primary">
        {LABELS.CONTINUE}
      </Button>

      <Box display="flex" alignItems="start" gap="medium" padding="large" borderRadius="medium" background="infoMuted">
        <Box flexShrink={0} paddingTop="xsmall">
          <InformationCircleIcon size="small" tone="info" />
        </Box>
        <Stack gap="medium">
          <Text weight="semibold">Don&apos;t meet the criteria?</Text>
          <Text size="small">
            Contact your vendor - they can help you explore other Brighte finance options for your home upgrade.
          </Text>
        </Stack>
      </Box>
    </Stack>
  );
}

export default TitleOwnerTerms;
